import { ReactNode } from "react";

import { SkillsContent } from "./SkillsContent";
import { SkillsWrapper } from "./SkillsWrapper";

import { SkillType } from "@/types";

export const SkillsView = ({
  skills,
  titleActions,
}: {
  skills: SkillType[];
  titleActions?: ReactNode;
}) => {
  return (
    <SkillsWrapper editControls={titleActions} isEmpty={!skills.length}>
      <SkillsContent skills={skills} />
    </SkillsWrapper>
  );
};
